<div class="resultItem">
    <div [ngClass]="{ 'page-text' : isSearchBar, 'search-page-text height-auto' : !isSearchBar}">
        <span class="title pageLink resultSearchLink" (click)="redirectPage($event)" (keydown.enter)="redirectPage($event)" [attr.tabindex]="initialTabindex">
            <img src="./assets/img/icon-play.svg" aria-disabled="true"> {{ title + ".TRANSLATION" | translate }}</span>
    </div>
    <div [ngClass]="{ 'path-text' : isSearchBar, 'search-path-text' : !isSearchBar}">
        <span>{{ description }}</span>
    </div>
</div> 
